import { useFormik } from 'formik';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import * as Yup from 'yup';
import {
  NewOAGFLogoSvg as OAGF,
  facebook,
  instagram,
  twitter,
  voxepay,
  youtube,
} from '../../../core/assets/imgs';
import { WhicHome } from '../../../core/helpers';

const profileDetailsSchema = Yup.object().shape({
  email: Yup.string().email('Wrong email format').required('Email is required'),
});

const initialValues = {
  email: '',
};

const Footer = () => {
  const [loading, setLoading] = useState(false);
  const { pathname } = useLocation();

  const formik = useFormik({
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: (values) => {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    },
  });

  const WhereToNavigate = () => {
    if (WhicHome() === 'mdaHome') {
      return '/';
    } else {
      return '/mda-home';
    }
  };
  const ToRouteHome = () => {
    if (WhicHome() === 'mdaHome') {
      if (pathname === '/mda-home') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
      return '/mda-home';
    } else {
      if (pathname === '/' && window.location.hash !== '') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
      return '/';
    }
  };

  const HelpRoute = () => {
    if (WhicHome() === 'mdaHome') {
      if (pathname === '/help-center') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
      return `/help-center`;
    } else {
      return `#help`;
    }
  };

  return (
    <div>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-logo">
            <img
              src={voxepay}
              alt="Logo"
              className="nav-logo"
              width={'136.737px'}
            />

            <span>Connect with us</span>

            <div>
              <ul className="social-icons-footer">
                <a href="#" className="social-icon-footer">
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="1"
                      y="1"
                      width="34"
                      height="34"
                      rx="17"
                      fill="white"
                    />
                    <rect
                      x="1"
                      y="1"
                      width="34"
                      height="34"
                      rx="17"
                      stroke="#E6EFFF"
                    />
                    <path
                      d="M22.0573 18.0143C22.0573 17.6894 22.0096 17.3357 21.914 16.9534H23.1183V22.7455C23.1183 22.8984 23.0657 23.0227 22.9606 23.1183C22.8554 23.2139 22.7264 23.2616 22.5735 23.2616H13.1398C12.9869 23.2616 12.8626 23.2139 12.767 23.1183C12.6714 23.0227 12.6237 22.8984 12.6237 22.7455V16.9534H13.7993C13.7037 17.3357 13.6559 17.6894 13.6559 18.0143C13.6559 18.5878 13.7658 19.1326 13.9857 19.6487C14.2055 20.1649 14.5066 20.6093 14.8889 20.9821C15.2712 21.3548 15.7204 21.6511 16.2366 21.871C16.7527 22.0908 17.2975 22.2007 17.871 22.2007C18.4444 22.2007 18.9892 22.0908 19.5054 21.871C20.0215 21.6511 20.466 21.3548 20.8387 20.9821C21.2115 20.6093 21.5078 20.1649 21.7276 19.6487C21.9474 19.1326 22.0573 18.5878 22.0573 18.0143ZM17.871 20.6237C17.5078 20.6237 17.1637 20.5568 16.8387 20.4229C16.5137 20.2891 16.2318 20.1027 15.9928 19.8638C15.7539 19.6249 15.5675 19.3477 15.4337 19.0323C15.2999 18.7168 15.233 18.3775 15.233 18.0143C15.233 17.6511 15.2999 17.307 15.4337 16.9821C15.5675 16.6571 15.7539 16.3751 15.9928 16.1362C16.2318 15.8973 16.5137 15.7109 16.8387 15.5771C17.1637 15.4432 17.5078 15.3763 17.871 15.3763C18.2342 15.3763 18.5735 15.4432 18.8889 15.5771C19.2043 15.7109 19.4815 15.8973 19.7204 16.1362C19.9594 16.3751 20.1458 16.6571 20.2796 16.9821C20.4134 17.307 20.4803 17.6511 20.4803 18.0143C20.4803 18.3775 20.4134 18.7168 20.2796 19.0323C20.1458 19.3477 19.9594 19.6249 19.7204 19.8638C19.4815 20.1027 19.2043 20.2891 18.8889 20.4229C18.5735 20.5568 18.2342 20.6237 17.871 20.6237ZM22.5735 12.767C22.7264 12.767 22.8554 12.8148 22.9606 12.9104C23.0657 13.006 23.1183 13.1302 23.1183 13.2832V14.8602C23.1183 15.0131 23.0657 15.1374 22.9606 15.233C22.8554 15.3286 22.7264 15.3763 22.5735 15.3763H20.9964C20.8435 15.3763 20.7192 15.3286 20.6237 15.233C20.5281 15.1374 20.4803 15.0131 20.4803 14.8602V13.2832C20.4803 13.1302 20.5281 13.006 20.6237 12.9104C20.7192 12.8148 20.8435 12.767 20.9964 12.767H22.5735ZM23.9785 6C24.8005 6 25.5795 6.15771 26.3154 6.47312C27.0514 6.78853 27.6918 7.21864 28.2366 7.76344C28.7814 8.30824 29.2115 8.94385 29.5269 9.67025C29.8423 10.3967 30 11.1708 30 11.9928V23.9785C30 24.8005 29.8423 25.5795 29.5269 26.3154C29.2115 27.0514 28.7814 27.6918 28.2366 28.2366C27.6918 28.7814 27.0514 29.2115 26.3154 29.5269C25.5795 29.8423 24.8005 30 23.9785 30H11.9928C11.1708 30 10.3967 29.8423 9.67025 29.5269C8.94385 29.2115 8.30824 28.7814 7.76344 28.2366C7.21864 27.6918 6.78853 27.0514 6.47312 26.3154C6.15771 25.5795 6 24.8005 6 23.9785V11.9928C6 11.1708 6.15771 10.3967 6.47312 9.67025C6.78853 8.94385 7.21864 8.30824 7.76344 7.76344C8.30824 7.21864 8.94385 6.78853 9.67025 6.47312C10.3967 6.15771 11.1708 6 11.9928 6H23.9785ZM24.6953 12.767C24.6953 12.3274 24.5424 11.9546 24.2366 11.6487C23.9307 11.3429 23.5579 11.19 23.1183 11.19H12.6237C12.184 11.19 11.8112 11.3429 11.5054 11.6487C11.1995 11.9546 11.0466 12.3274 11.0466 12.767V23.2616C11.0466 23.7013 11.1995 24.0741 11.5054 24.3799C11.8112 24.6858 12.184 24.8387 12.6237 24.8387H23.1183C23.5579 24.8387 23.9307 24.6858 24.2366 24.3799C24.5424 24.0741 24.6953 23.7013 24.6953 23.2616V12.767Z"
                      fill="#0866FF"
                    />
                  </svg>
                </a>{' '}
                <a href="#" className="social-icon-footer">
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="1"
                      y="1"
                      width="34"
                      height="34"
                      rx="17"
                      fill="white"
                    />
                    <rect
                      x="1"
                      y="1"
                      width="34"
                      height="34"
                      rx="17"
                      stroke="#E6EFFF"
                    />
                    <path
                      d="M24.0072 6C24.8292 6 25.6033 6.15771 26.3298 6.47312C27.0562 6.78853 27.6918 7.21864 28.2366 7.76344C28.7814 8.30824 29.2115 8.94385 29.5269 9.67025C29.8423 10.3967 30 11.1708 30 11.9928V23.9785C30 24.8005 29.8423 25.5795 29.5269 26.3154C29.2115 27.0514 28.7814 27.6918 28.2366 28.2366C27.6918 28.7814 27.0562 29.2115 26.3298 29.5269C25.6033 29.8423 24.8292 30 24.0072 30H11.9928C11.1708 30 10.3967 29.8423 9.67025 29.5269C8.94385 29.2115 8.30824 28.7814 7.76344 28.2366C7.21864 27.6918 6.78853 27.0514 6.47312 26.3154C6.15771 25.5795 6 24.8005 6 23.9785V11.9928C6 11.1708 6.15771 10.3967 6.47312 9.67025C6.78853 8.94385 7.21864 8.30824 7.76344 7.76344C8.30824 7.21864 8.94385 6.78853 9.67025 6.47312C10.3967 6.15771 11.1708 6 11.9928 6H24.0072ZM22.4875 11.2473H19.9642C19.4671 11.2473 19.0084 11.3333 18.5878 11.5054C18.1673 11.6774 17.8041 11.902 17.4982 12.1792C17.1924 12.4564 16.9486 12.7766 16.767 13.1398C16.5854 13.503 16.4946 13.8662 16.4946 14.2294V15.7491H14.2581V18.7312H16.4946V24.7527H19.5054V18.7312H21.7419V15.7491H19.5054V15.0036C19.5054 14.7551 19.5962 14.5639 19.7778 14.4301C19.9594 14.2963 20.1171 14.2294 20.2509 14.2294H22.4875V11.2473Z"
                      fill="#0866FF"
                    />
                  </svg>
                </a>
                <a href="#" className="social-icon-footer">
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="1"
                      y="1"
                      width="34"
                      height="34"
                      rx="17"
                      fill="white"
                    />
                    <rect
                      x="1"
                      y="1"
                      width="34"
                      height="34"
                      rx="17"
                      stroke="#E6EFFF"
                    />
                    <path
                      d="M17.9857 6C19.6487 6 21.2067 6.31541 22.6595 6.94624C24.1123 7.57706 25.3835 8.4325 26.4731 9.51254C27.5627 10.5926 28.4229 11.859 29.0538 13.3118C29.6846 14.7646 30 16.3226 30 17.9857C30 19.6487 29.6846 21.2067 29.0538 22.6595C28.4229 24.1123 27.5627 25.3835 26.4731 26.4731C25.3835 27.5627 24.1123 28.4229 22.6595 29.0538C21.2067 29.6846 19.6487 30 17.9857 30C16.3226 30 14.7646 29.6846 13.3118 29.0538C11.859 28.4229 10.5926 27.5627 9.51254 26.4731C8.4325 25.3835 7.57706 24.1123 6.94624 22.6595C6.31541 21.2067 6 19.6487 6 17.9857C6 16.3226 6.31541 14.7646 6.94624 13.3118C7.57706 11.859 8.4325 10.5926 9.51254 9.51254C10.5926 8.4325 11.859 7.57706 13.3118 6.94624C14.7646 6.31541 16.3226 6 17.9857 6ZM14.2581 15.0036H11.2473V24.7527H14.2581V15.0036ZM12.7384 14.2294C13.1589 14.2294 13.5173 14.086 13.8136 13.7993C14.1099 13.5125 14.2581 13.1589 14.2581 12.7384C14.2581 12.3178 14.1099 11.9642 13.8136 11.6774C13.5173 11.3907 13.1589 11.2473 12.7384 11.2473C12.3178 11.2473 11.9642 11.3907 11.6774 11.6774C11.3907 11.9642 11.2473 12.3178 11.2473 12.7384C11.2473 13.1589 11.3907 13.5125 11.6774 13.7993C11.9642 14.086 12.3178 14.2294 12.7384 14.2294ZM24.7527 19.1039C24.7527 18.4158 24.5615 17.7419 24.1792 17.0824C23.7969 16.4229 23.2999 15.9211 22.6882 15.5771C22.1338 15.2712 21.4887 15.1087 20.7527 15.0896C20.0167 15.0705 19.3429 15.1947 18.7312 15.4624V15.0036H15.7491V24.7527H18.7312V18.7885L19.9928 18.1864C20.1458 18.1099 20.3513 18.0717 20.6093 18.0717C20.8674 18.0717 21.0729 18.1195 21.2258 18.2151C21.3405 18.2724 21.4552 18.3967 21.5699 18.5878C21.6846 18.779 21.7419 18.951 21.7419 19.1039V24.7527H24.7527V19.1039Z"
                      fill="#0866FF"
                    />
                  </svg>
                </a>
                <a href="#" className="social-icon-footer">
                  <svg
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="1"
                      y="1"
                      width="34"
                      height="34"
                      rx="17"
                      fill="white"
                    />
                    <rect
                      x="1"
                      y="1"
                      width="34"
                      height="34"
                      rx="17"
                      stroke="#E6EFFF"
                    />
                    <rect
                      x="6"
                      y="6"
                      width="24"
                      height="24"
                      rx="3"
                      fill="#0866FF"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M25.1578 25L19.5597 16.8405L19.5693 16.8482L24.6167 11H22.93L18.8182 15.76L15.5529 11H11.1292L16.3555 18.6179L16.3549 18.6173L10.8428 25H12.5295L17.1009 19.7042L20.7341 25H25.1578ZM14.8846 12.2727L22.739 23.7273H21.4024L13.5416 12.2727H14.8846Z"
                      fill="white"
                    />
                  </svg>
                </a>{' '}
              </ul>
            </div>
          </div>
          <div className="footer-center">
            <span className="footer-quick-link">Discover</span>
            <span className="my-3 d-flex align-items-center footer-quick-link-text fs-9 ">
              Business
            </span>
            <span className="my-3 d-flex align-items-center footer-quick-link-text fs-9 ">
              Developers
            </span>
            <span className="my-3 d-flex align-items-center footer-quick-link-text fs-9 ">
              Personal
            </span>
          </div>

          <div className="footer-center">
            <span className="footer-quick-link">Get In Touch</span>

            <span className="my-3 d-flex align-items-center">
              <svg
                width="38"
                height="38"
                viewBox="0 0 38 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="38" height="38" rx="19" fill="#FAFAFF" />
                <path
                  d="M25.75 13.0938H12.25C12.0262 13.0938 11.8116 13.1826 11.6534 13.3409C11.4951 13.4991 11.4062 13.7137 11.4062 13.9375V23.5C11.4062 23.873 11.5544 24.2306 11.8181 24.4944C12.0819 24.7581 12.4395 24.9062 12.8125 24.9062H25.1875C25.5605 24.9062 25.9181 24.7581 26.1819 24.4944C26.4456 24.2306 26.5938 23.873 26.5938 23.5V13.9375C26.5938 13.7137 26.5049 13.4991 26.3466 13.3409C26.1884 13.1826 25.9738 13.0938 25.75 13.0938ZM23.5809 14.7812L19 18.9803L14.4191 14.7812H23.5809ZM13.0938 23.2188V15.8556L18.4298 20.7473C18.5854 20.89 18.7889 20.9691 19 20.9691C19.2111 20.9691 19.4146 20.89 19.5702 20.7473L24.9062 15.8556V23.2188H13.0938Z"
                  fill="#0866FF"
                />
              </svg>

              <span className="footer-quick-link-text-2 fs-9 ms-1">
                info@voxepay.com
              </span>
            </span>

            <span className="my-3 d-flex align-items-center">
              <svg
                width="38"
                height="38"
                viewBox="0 0 38 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="38" height="38" rx="19" fill="#FAFAFF" />
                <path
                  d="M25.75 20.8846L22.439 19.4003L22.4263 19.3946C22.2111 19.3018 21.9761 19.2645 21.7427 19.286C21.5093 19.3075 21.285 19.3871 21.0904 19.5177C21.0631 19.5359 21.0368 19.5557 21.0116 19.5767L19.443 20.9127C18.5289 20.417 17.5846 19.4804 17.0882 18.5776L18.4284 16.9843C18.4499 16.9586 18.4699 16.9316 18.4881 16.9035C18.6152 16.7095 18.6924 16.4871 18.7128 16.2561C18.7331 16.0251 18.6961 15.7927 18.6048 15.5795C18.6027 15.5754 18.6008 15.5712 18.5992 15.5668L17.1156 12.2502C16.9939 11.9728 16.786 11.742 16.5229 11.592C16.2597 11.4419 15.9553 11.3805 15.6545 11.417C14.6339 11.5511 13.6969 12.0521 13.0186 12.8265C12.3403 13.6009 11.9672 14.5957 11.9688 15.6252C11.9688 21.3634 16.6368 26.0314 22.375 26.0314C23.4045 26.033 24.3993 25.6598 25.1737 24.9816C25.9481 24.3033 26.4491 23.3663 26.5832 22.3456C26.6196 22.0449 26.5583 21.7405 26.4082 21.4773C26.2582 21.2142 26.0274 21.0063 25.75 20.8846ZM22.375 24.3439C20.0635 24.3411 17.8475 23.4217 16.213 21.7872C14.5785 20.1527 13.659 17.9367 13.6563 15.6252C13.6546 15.0426 13.8524 14.4771 14.2167 14.0225C14.581 13.5679 15.0899 13.2516 15.6588 13.1263L16.982 16.0794L15.6348 17.6839C15.6131 17.7099 15.5929 17.7371 15.5744 17.7655C15.4416 17.9684 15.3635 18.2022 15.3478 18.4441C15.332 18.6861 15.3791 18.928 15.4844 19.1464C16.1467 20.5021 17.5115 21.8577 18.8812 22.5214C19.101 22.6257 19.3442 22.6711 19.5869 22.6532C19.8295 22.6353 20.0634 22.5548 20.2656 22.4195C20.2928 22.4011 20.3189 22.3812 20.3437 22.3597L21.9208 21.0189L24.8739 22.3414C24.7485 22.9103 24.4323 23.4192 23.9777 23.7835C23.5231 24.1478 22.9575 24.3455 22.375 24.3439Z"
                  fill="#0866FF"
                />
              </svg>

              <span className="footer-quick-link-text-2 fs-9 ms-1">
                (+234)9121145050
              </span>
            </span>

            <span className="my-3 d-flex ">
              <svg
                width="38"
                height="38"
                viewBox="0 0 38 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="38" height="38" rx="19" fill="#FAFAFF" />
                <path
                  d="M19 14.2188C18.3881 14.2188 17.79 14.4002 17.2812 14.7401C16.7724 15.0801 16.3759 15.5633 16.1417 16.1286C15.9076 16.6939 15.8463 17.3159 15.9657 17.9161C16.0851 18.5162 16.3797 19.0674 16.8124 19.5001C17.2451 19.9328 17.7963 20.2274 18.3964 20.3468C18.9966 20.4662 19.6186 20.4049 20.1839 20.1708C20.7492 19.9366 21.2324 19.5401 21.5724 19.0313C21.9123 18.5225 22.0938 17.9244 22.0938 17.3125C22.0928 16.4923 21.7666 15.7059 21.1866 15.1259C20.6066 14.5459 19.8202 14.2197 19 14.2188ZM19 18.7188C18.7219 18.7188 18.45 18.6363 18.2187 18.4818C17.9875 18.3272 17.8072 18.1076 17.7008 17.8506C17.5944 17.5937 17.5665 17.3109 17.6208 17.0382C17.675 16.7654 17.809 16.5148 18.0056 16.3181C18.2023 16.1215 18.4529 15.9875 18.7257 15.9333C18.9984 15.879 19.2812 15.9069 19.5381 16.0133C19.7951 16.1197 20.0147 16.3 20.1693 16.5312C20.3238 16.7625 20.4062 17.0344 20.4062 17.3125C20.4062 17.6855 20.2581 18.0431 19.9944 18.3069C19.7306 18.5706 19.373 18.7188 19 18.7188ZM19 10.8438C17.285 10.8456 15.6407 11.5277 14.428 12.7405C13.2152 13.9532 12.5331 15.5975 12.5312 17.3125C12.5312 22.7519 18.2716 26.8328 18.5163 27.0037C18.658 27.1029 18.8269 27.1561 19 27.1561C19.1731 27.1561 19.342 27.1029 19.4838 27.0037C20.571 26.2024 21.5657 25.2827 22.4495 24.2615C24.4246 21.9932 25.4688 19.5885 25.4688 17.3125C25.4669 15.5975 24.7848 13.9532 23.572 12.7405C22.3593 11.5277 20.715 10.8456 19 10.8438ZM21.2008 23.128C20.5304 23.8981 19.794 24.6082 19 25.2501C18.206 24.6082 17.4696 23.8981 16.7992 23.128C15.625 21.7682 14.2188 19.6546 14.2188 17.3125C14.2188 16.0444 14.7225 14.8283 15.6191 13.9316C16.5158 13.035 17.7319 12.5312 19 12.5312C20.2681 12.5312 21.4842 13.035 22.3809 13.9316C23.2775 14.8283 23.7812 16.0444 23.7812 17.3125C23.7812 19.6546 22.375 21.7682 21.2008 23.128Z"
                  fill="#0866FF"
                />
              </svg>

              <span className="footer-quick-link-text-2 fs-9 ms-1">
                18, A-Close, 14 Road, Gwarimpa, Abuja, FCT
              </span>
            </span>
          </div>

     
        </div>

                <div className='footer-cen'>
          <a href='/privacyPolicy' target='blank'><span>Privacy Policy</span>  </a>
         <a href='/termsConditions' target='blank'>   <span>Terms and Conditions</span></a>
        </div>

     

        <footer>
          <div className="footer-bottom">
            <span className="footer-bottom-div ">
              Copyright © 2024&nbsp;
              <span style={{ color: '#6366F1', cursor: 'pointer' }}>
                VoxePay
              </span>{' '}
              All rights reserved.
            </span>
          </div>
        </footer>
      </footer>
    </div>
  );
};

export { Footer };
